<template>
  <nav class="menu-container">

    <RouterLink
      :exact="item.exact"
      v-for="item in items"
      :key="item.link"
      :to="{ name: item.name }"
      active-class="selected"
      exact-active-class=""
    >
      <div class="icon">
        <Icon :type="item.icon" />
      </div>
      <span>{{ item.title }}</span>
    </RouterLink>
    体育中心站<br>
站点介绍<br>
体育中心站位于上步北路和笋岗路交叉口，沿上步北路呈南北向布置。与笋岗线换乘。车站周边现状为成熟建成区，东侧主要为园岭新村、园岭供水所，西侧有百花园小区及西北角的深圳体育馆、 体育中<br>心站为地下二层岛式车站，地下一层为站厅层，地下二层为站台层。车站为地下2层明挖车站。<br>
运营时刻表(工作日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
科学馆	06:24	00:07	6号线	3分24秒	6分20秒<br>
松岗	06:23	23:03	6号线	3分24秒	6分20秒<br><br>
运营时刻表(休息日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
科学馆	06:23	00:07	6号线	4分45秒	6分钟<br>
松岗	06:23	23:03	6号线	4分45秒	6分钟<br><br>
运营时刻表(节假日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
科学馆	06:23	01:07	6号线	4分45秒	6分钟<br>
松岗	06:23	00:03	6号线	4分45秒	6分钟<br><br>
<br>
站点出口信息<br>
A1:<br>
上步中路东侧(南)、红荔社区居委会、园岭外国语小学、园岭实验小学、园岭新村<br><br>
A2:<br>
上步中路西侧(南)、深圳艺术学校、园岭街道办<br><br>
A3:<br>
上步中路西侧(南)、深圳艺术学校、园岭街道办<br><br>
B:<br>
笋岗西路南侧(西))、深圳市体育中心、体育南社区公园<br><br>
公交换乘信息<br><br>
A1出入口:<br>
公交站名：<br>
4路,8路,363路,385路,393路,M132路,M389路,N17路、A2./. A3<br><br>
B出入口:<br>
公交站名：<br>
11路,79路,102路,107路,111路,213路,M207路,320路,323路,333路,357路,E5路,E11路,E20路,M165路,M203路,M329路,M401路,M414路,高快巴士12<br>
</nav>
</template>

<script>
// import Icon from "@/components/Icon";
export default {
  components: {
    // Icon,
  },
  data() {
    return {
      items: [
        {
          name: "liuhaoxian",
          title: "6号线",
          // icon: "chat",
          exact: true,
        },
      ],
    };
  },
};
</script>

<style scoped lang="less">
@import "~@/styles/var.less";
.menu-container {
  color: @words;
  margin: 24px 0;
  a {
    &.selected {
      background: darken(@words, 3%);
    }
    padding: 0 50px;
    display: block;
    display: flex;
    align-items: center;
    height: 45px;
    // .icon {
    //   width: 24px;
    // }
    &:hover {
      color: rgb(50, 95, 227);
    }
  }
}
</style>